module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ge-Hc-Ic-Ja.b9c1bb4f.png";